import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';

export const FAQ = () => {
  useEffect(() => {
    getWindowDimensions();
  }, []);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;
  return (
    <FaqWrapper width={width}>
      <HeaderWrapper>
        <PageTitle>Frequently asked questions</PageTitle>
        <TradeText>
          If you have another question, please{' '}
          <HeadingA href="https://t.me/iconswap">join us on Telegram</HeadingA>.
          We'd love to help you!
        </TradeText>
      </HeaderWrapper>
      <FaqBody>
        <LeftColumn>
          <ModuleWrapper>
            <ModuleHeader>What is ICONswap?</ModuleHeader>
            <ModuleBody>
              ICONswap is a decentralized exchange that enables you to safely
              trade and swap your IRC2 tokens. All tokens are paired with ICX.
            </ModuleBody>
          </ModuleWrapper>
          <ModuleWrapper>
            <ModuleHeader>How do I create a swap?</ModuleHeader>
            <ModuleBody>
              First, you’ll need to connect your ICON wallet. Click “Create a
              swap” button, and you’ll be prompted to log in. You will then be
              taken to a modal, where you’ll create your swap. Simply, choose
              what token you have to swap, and the token you want to swap it
              for, and specify a price. For example, you could swap 15,000 ICX
              for 300,000 TAP.
            </ModuleBody>
          </ModuleWrapper>
          <ModuleWrapper>
            <ModuleHeader>How do I buy a swap?</ModuleHeader>
            <ModuleBody>
              If you see a swap that you want to buy, simply click on it, and
              you’ll be taken to the swap details page, where you can buy it.
              Once you deposit the requested token, the swap will be executed.
            </ModuleBody>
          </ModuleWrapper>
        </LeftColumn>
        <RightColumn>
          <ModuleWrapper>
            <ModuleHeader>How do I cancel a swap?</ModuleHeader>
            <ModuleBody>
              You can view your pending swaps on your account page. To cancel a
              swap that hasn’t been completed yet, simply click on the swap and
              you’ll see a button to “Withdraw your swap”. Click this and your
              swap will be canceled.
            </ModuleBody>
          </ModuleWrapper>
          <ModuleWrapper>
            <ModuleHeader>
              How can I reach the team that runs this site?
            </ModuleHeader>
            <ModuleBody>
              Feel free to reach out to the team, and wider community via
              Telegram for further assistance:{' '}
              <TelegramLink href="https://t.me/iconswap">
                https://t.me/iconswap
              </TelegramLink>
            </ModuleBody>
          </ModuleWrapper>
        </RightColumn>
      </FaqBody>
    </FaqWrapper>
  );
};

export default FAQ;

const FaqWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  background-color: #f1f8fc;
  height: 1600px;
  ${(props: WidthType) => {
    const setWidth = props.width - 250;
    const setWidthString = setWidth.toString() + 'px';
    return css`
      width: ${setWidthString};
    `;
  }}
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    width: 100vw;
    height: 100%;
    padding-bottom: 100px;
  }
`;

const HeaderWrapper = styled.div`
  width: 1055px;
  @media (max-width: 414px) {
    width: 100vw;
    padding-left: 20px;
    padding-top: 40px;
  }
`;

const PageTitle = styled.h1`
  font-size: 38px;
  margin-bottom: 8px;
  padding-top: 100px;
  color: #100f10;
  font-family: 'Tiempos Headline';
  font-size: 38px;
  @media (max-width: 414px) {
    width: 335px;
    margin-left: 0px;
    padding-top: 0px;
    font-size: 22px;
    font-family: 'Tiempos Headline';
    font-weight: 600;
  }
`;

const TradeText = styled.div`
  padding-top: 8px;
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  @media (max-width: 414px) {
    width: 335px;
    font-size: 15px;
    font-family: 'Avenir Next';
    font-weight: 500;
  }
`;

const FaqBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (max-width: 414px) {
    flex-direction: column;
  }
`;

const LeftColumn = styled.div`
  margin-right: 57px;
  @media (max-width: 414px) {
    margin-right: 0;
  }
`;

const RightColumn = styled.div``;

const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 66px;
`;

const ModuleHeader = styled.span`
  color: #0e0d0e;
  font-family: 'Avenir Next';
  font-size: 20px;
  font-weight: 600;
  width: 499px;
  padding-bottom: 14px;
  @media (max-width: 414px) {
    width: 90vw;
  }
`;

const ModuleBody = styled.span`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  width: 499px;
  @media (max-width: 414px) {
    width: 90vw;
  }
`;

const TelegramLink = styled.a`
  text-decoration: inherit;
  color: inherit;
`;

const HeadingA = styled.a`
  color: #007d81;
  font-weight: 600;
`;

type WidthType = {
  width: number;
};
